export class Debounce {
  private debounceTime: number;
  private timeout: ReturnType<typeof setTimeout> | null = null;

  constructor(debounceTime: number) {
    this.debounceTime = debounceTime;
  }

  public debounce = (callback: () => void) => {
    this.timeout && clearTimeout(this.timeout);
    this.timeout = setTimeout(callback, this.debounceTime);
  };

  public destroy = () => this.timeout && clearTimeout(this.timeout);
}
